module.exports = __webpack_public_path__ + "static/img/ser-b-1.40f5ac8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/setmeal/ser-b-1.png
// module id = 13I+
// module chunks = 1